import React, { Suspense } from 'react';
import { importRemote } from 'module-federation-import-remote';
import { PageLoading } from '@dtna/dvs-core-dcp-ui-libraries';
import { getMfeUrl } from '@dtna/dvs-core-dcp-client-utils/lib/utils/mfe';
import { mfeLazyLoadErrorHandler } from '../../utils/mfe';

const Geofencing = React.lazy(() => importRemote<any>({
  url: getMfeUrl('GEOFENCING'),
  scope: 'Geofencing',
  module: 'App',
  bustRemoteEntryCache: false,
}).catch(mfeLazyLoadErrorHandler));

export default function GeofencingWrapper({ navbarLoaded }: { navbarLoaded: boolean }) {
  return (
    <Suspense fallback={<PageLoading navbarLoaded={navbarLoaded} />}>
      <Geofencing />
    </Suspense>
  );
}
